import React, {Component} from 'react';
import KuaishouEditPage from "../../../view/mediaRelease/components/kuaishouEditPage";
import noData from "../../../view/mediaRelease/image/noData.png";
import {rmtMessage} from "../../../view/mediaRelease/components/mess";
import {base64Encode, permissionCheck, uuid} from "../../../utils";
import {Modal, Button, Progress, Icon, Input, Radio} from "antd";
import UploadVideo from "../../../view/mediaRelease/quickHand/uploadVideo/uploadVideo";
import Titlepicfile from "../../../view/components/titlepicfile/Titlepicfile";
import {Scrollbars} from "react-custom-scrollbars";
import Publisher from "./Publisher";
import SelectColumn from "../../../view/editor/components/publishInItem/rmSelectColumn";
import OtherAttributes from "../../../view/editor/components/publishInItem/rmOtherAttributes";
import CurrencyResourceDialog from "../../../view/resource/view/dialog/CurrencyResourceDialog";
import VideoEdit from "./VideoEdit";

const {TextArea} = Input;
class Video extends KuaishouEditPage {

    constructor(props) {
        super(props);
        this.state.releaseVideosVisible = false;
        this.state.titleModal = "发视频";
        this.state.coverPicType = this.props.coverPicType || 1;//默认封面小图
        this.state.videoInitInfo = {}
    }

    async componentDidMount() {
        const videoInitInfo = await this.props.dynamicParams();
        this.setState({
            videoInitInfo
        })
    }

    showAddDialog(){
        this.setState({releaseVideosVisible:true})
    }

    show = ({
                id, title, content, titlePic, deliveryMediaFusionList, top, recommend, viewNum,statusName, submitter, columnId, columnName, mediaId, mediaName,
                variableFields:{videoDuration, videoFileLen, videoName, videoUrl, coverPicType = 1, publishId, publishName, publishType, permission, editWidth, editHeight, videoSrc, initViewNum}
    }) => {
        this.otherAttributesInfo = {top, recommend, viewNum, initViewNum};
        this.deliveryNews = deliveryMediaFusionList;
        this.mainColumn = columnId ? {columnId, columnName, mediaId, mediaName} : null
        this.setState({
            visible: true, releaseVideosVisible:false,
            body:{id, title, content, coverUrl:titlePic, videoDuration, videoFileLen, videoSrc, videoName, videoUrl, editWidth, editHeight, statusName, submitter, variableFields:{publishId,publishName,publishType, permission}},
            deliveryNews:deliveryMediaFusionList, coverPicType
        })
    };

    render() {
        return <div>
            {this.renderInfo()}
            {this.renderReleaseVideos()}
            {this.renderPublishDialog()}
            {/*本地上传,资源库弹窗*/}
            <UploadVideo maxSize={500} limitDuration={false} ref={ref => this.uploadVideo = ref}/>
        </div>;
    }

    renderInfo(){
        let {visible, body, titleModal} = this.state;
        return <Modal
            title={titleModal}
            maskClosable={false}
            keyboard={false}
            centered
            zIndex={500}
            visible={visible}
            onCancel={() => {
                this.setState({visible: false});
                this.props.onOkCall()
            }}
            width={750}
            footer={
                <div>
                    <Button onClick={() => {
                        this.save("已发布","发布");
                    }} type="primary">发布</Button>
                    {(!body.statusName || (body.statusName === "草稿" && body.submitter === window.currentUser.id)) ?
                        <Button onClick={() => {
                            this.save();
                        }} type="primary">暂存</Button> : null
                    }
                    <Button onClick={() => {
                        this.setState({publishDialogVisible: true})
                    }}>发布设置</Button>
                    <Button onClick={() => {
                        this.hide(() => this.props.onOkCall());
                    }}>取消</Button>
                </div>}
        >
            <Scrollbars autoHeight autoHeightMax={500}>
                <div style={{marginRight:10, paddingRight: 10}}>
                    {/*新增弹框左面部分*/}
                    {this.renderInfoForm()}
                    {this.renderEditCoverModal()}
                    {this.renderUploadPicture()}
                </div>
            </Scrollbars>
        </Modal>
    }

    //发布视频按钮第一层弹框
    renderReleaseVideos = () => {
        return (
            <Modal
                centered
                visible={this.state.releaseVideosVisible}
                onCancel={() => {
                    this.setState({
                        releaseVideosVisible: false
                    })
                }}
                width={1200}
                bodyStyle={{height: 718}}
                footer={null}
            >
                <div style={{
                    position: 'relative',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,

                    margin: 'auto',
                    paddingTop: 32
                }}>
                    <div style={{textAlign: 'center',}}>
                        <img style={{width: 400, height: 299.37}} src={noData}/>
                        <div style={{marginTop: -30, fontWeight: 500, fontSize: 22, color: 'rgba(0,0,0,0.85)'}}>创作开始
                        </div>
                        <div>
                            <Button onClick={() => {
                                this.uploadVideo.show((atlasList)=>{
                                    if(atlasList && atlasList.length > 0){
                                        let newBody = {...this.state.body, titlePic: this.state.body.coverUrl}
                                        this.show({...newBody, variableFields: {
                                                videoDuration : atlasList[0].duration,
                                                videoFileLen : atlasList[0].size,
                                                videoName : atlasList[0].name,
                                                videoUrl : atlasList[0].mp4Path,
                                                // coverUrl : atlasList[0].url,  这里不能使用默认图片，否则编辑封面会报错
                                                editWidth: atlasList[0].width,
                                                editHeight: atlasList[0].height,
                                                videoSrc: atlasList[0].url
                                            }});
                                    }
                                    this.setState({releaseVideosVisible: false})
                                });
                                // this.uploadVideo.show(this.props.onUploadVideoCall);
                                // this.uploadVideo.empty(this.props.cancelEmpty)
                            }} type="primary" style={{borderRadius: 0, marginTop: 24}}>本地上传</Button>
                           <Button onClick={() => {
                                    this.resourceDialog.show()
                                }}  style={{borderRadius: 0, marginTop: 24,marginLeft:24}}>资源库选择</Button>
                        </div>
                        <CurrencyResourceDialog
                            singleChoice = {true}
                            onCallBackOk={(checkedData,call)=>{
                                if (checkedData.length !=1){
                                    call&&call(false);
                                    rmtMessage.destroy();
                                    rmtMessage.warning("请选择一个视频！")
                                }else {
                                    call&&call(true);
                                    if(checkedData[0].size/1024/1024>500){
                                        rmtMessage.destroy();
                                        rmtMessage.warning("暂不支持上传500M以上的视频！")
                                        return false;
                                    }
                                    this.show({variableFields: {
                                            videoDuration : checkedData[0].duration,
                                            videoFileLen : checkedData[0].size,
                                            videoName : checkedData[0].name,
                                            videoUrl : checkedData[0].mp4Path,
                                            editWidth: checkedData[0].width,
                                            editHeight: checkedData[0].height,
                                            videoSrc: checkedData[0].url
                                        }});
                                    this.setState({releaseVideosVisible: false});
                                }
                            }}
                            indexName={"video"}
                            ref={resourceDialog=>this.resourceDialog = resourceDialog} />
                    </div>
                    <div style={{display: 'flex', justifyContent: 'center', paddingTop: 80}}>
                        <div style={{
                            width: 240,
                            height: 122,
                            background: 'rgba(0,80,179,0.04)',
                            paddingLeft: 24,
                            paddingTop: 24
                        }}>
                            <p style={{fontWeight: 500, fontSize: 16}}>推荐尺寸</p>
                            <p style={{fontSize: 14, color: 'rgba(0,0,0,0.45)'}}>16:9的横版视频<br/>9:16的竖版视频</p>
                        </div>
                        <div style={{
                            width: 240,
                            height: 122,
                            background: 'rgba(0,80,179,0.04)',
                            marginLeft: 40,
                            paddingLeft: 24,
                            paddingTop: 24
                        }}>
                            <p style={{fontWeight: 500, fontSize: 16}}>视频大小</p>
                            <p style={{fontSize: 14, color: 'rgba(0,0,0,0.45)'}}>支持最大500M<br/>的视频文件</p>
                        </div>
                        <div style={{
                            width: 240,
                            height: 122,
                            background: 'rgba(0,80,179,0.04)',
                            marginLeft: 40,
                            paddingLeft: 24,
                            paddingTop: 24
                        }}>
                            <p style={{fontWeight: 500, fontSize: 16}}>参考视频</p>
                            <p style={{fontSize: 14, color: 'rgba(0,0,0,0.45)'}}>推荐上传720p (1280x720) 及<br/>以上要求的视频</p>
                        </div>
                        <div style={{
                            width: 240,
                            height: 122,
                            background: 'rgba(0,80,179,0.04)',
                            marginLeft: 40,
                            paddingLeft: 24,
                            paddingTop: 24
                        }}>
                            <p style={{fontWeight: 500, fontSize: 16}}>视频格式</p>
                            <p style={{fontSize: 14, color: 'rgba(0,0,0,0.45)'}}>支持常用视频格式，推荐使用<br/>mp4</p>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }

    videoEditCallback = (obj) => {
        this.setState({
            body: {
                ...this.state.body,
                videoUrl: obj.path,
                videoFileLen: obj.size,
                videoDuration: obj.duration,
                videoName: obj.name,
                editWidth:obj.width,
                editHeight:obj.height
            }
        })
    }

    //新增页面
    renderInfoForm = () => {
        let {body} = this.state;
        let {
            coverUrl = "",
            title = "",
            content = "",
            videoDuration = 0,
            videoFileLen = 0,
            videoName = "",
            videoUrl = "",
        } = body;
        let {mediaName, mediaId, rmType} = this.state.videoInitInfo;
        let publishType = this.state.body?.variableFields?.publishType;
        return (
            <div>
                {/*视频名和进度条*/}
                <div style={{
                    height: 86,
                    backgroundColor: 'rgba(0,80,179,0.04)',
                    fontSize: '14px',
                    paddingTop: 12
                }}>
                    <div style={{display: 'flex', justifyContent: 'space-between', paddingLeft: 24}}>
                        <div style={{
                            width: 102,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }} title={videoName}>{videoName}</div>
                        <div style={{display: 'flex', marginRight: 24}}>
                            <p style={{paddingRight: 24}}>大小:{" "}{this.bToMb(videoFileLen)}MB</p>
                            <p>视频时长:{" "}{this.timeCycle(videoDuration)}S</p>
                        </div>
                    </div>
                    {/*进度条*/}
                    <div style={{paddingLeft: 24, marginTop: -10}}>
                        {videoUrl ? <Progress strokeLinecap="square" percent={100} strokeColor={'blue'}/> : null}
                    </div>
                    <div style={{display: "flex", justifyContent: "flex-end", alignItems: "center", marginRight: 35}}>
                        {/*视频编辑*/}
                        <div style={{marginLeft: 20}}>
                            <VideoEdit videoUrl={videoUrl} videoName={videoName} videoEditCallback={this.videoEditCallback}/>
                        </div>
                        {/*重新上传*/}
                        <div style={{color: '#0050B3', cursor: 'pointer', marginLeft: 20}} onClick={() => this.showAddDialog()}>重新上传</div>
                    </div>
                </div>
                {/*视频标题*/}
                <div style={{paddingTop: 24}}>
                    <p style={{fontSize: '16px', fontWeight: 500, color: 'black'}}><span
                        style={{color: "red"}}>*</span>{" "}视频标题：</p>
                    <Input value={title} onChange={e=>{
                        this.state.body.title = e.target.value;
                        this.setState({})
                    }} placeholder={"请填写视频标题"} style={{backgroundColor:"rgba(246, 248, 253, 0.86) !important"}} />
                </div>
                {/*视频描述*/}
                <div style={{paddingTop: 24}}>
                    <p style={{fontSize: '16px', fontWeight: 500, color: 'black'}}><span
                        style={{color: "red"}}>*</span>{" "}视频描述：</p>

                    <div style={{border: '1px solid rgba(0,80,179,0.08)'}}>
                        <Scrollbars autoHeight autoHeightMax={70}>
                            {/*<div style={{width:'auto', height:'auto',}}>*/}
                            <TextArea
                                value={content}
                                disabled={this.state.disabled}
                                placeholder={this.state.placeholder}
                                maxLength={100}
                                onChange={(e) => {
                                    this.state.body.content = e.target.value;
                                    this.setState({})
                                }}
                                autoSize={{minRows: 3}}
                                style={{
                                    width: 682,
                                    border: 'none',
                                    resize: 'none',
                                    backgroundColor: 'rgba(0,80,179,0.04)',
                                    borderRadius: '5px 0 0 5px'
                                }}
                            />
                        </Scrollbars>
                        <div style={{
                            width: 682,
                            textAlign: "right",
                            boxSizing: "borderBox",
                            paddingRight: 20,
                            backgroundColor: 'rgba(0,80,179,0.04)'
                        }}>
                            <span>{content.length ? content.length : 0}</span>
                            <span>/</span>
                            <span>100</span>
                        </div>
                    </div>
                </div>
                {/*视频封面*/}
                <div style={{paddingTop: 54}}>
                    <p style={{fontSize: '16px', fontWeight: 500, color: 'black'}}><span
                        style={{color: "red"}}>*</span>{" "}视频封面</p>
                    <div style={{display: 'flex', marginBottom: 16}}>
                        {/*<img  style={{width: 88, height: 88,objectFit:'contain'}} src={coverUrl}/>*/}
                        {coverUrl ?
                            <Titlepicfile src={coverUrl} style={{
                                width: 88,
                                height: 88,
                                border: "1px solid #E1EAF6",
                                borderRadius: 2,
                                background: "#F5F8FC"
                            }}/>:
                            <div style={{
                                width: 88,
                                height: 88,
                                border: "1px solid #E1EAF6",
                                borderRadius: 2,
                                background: "#F5F8FC",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-evenly",
                                alignItems: "center"
                            }}
                                 onClick={
                                     () => {
                                         if (body.statusName !== "已发布") {
                                             this.setState({uploadPictureVisible: true});
                                             this.state.uploadImage = uuid();
                                         }
                                     }
                                 }
                            >
                                <Icon type={this.state.loading ? 'loading' : 'plus'}/>
                                <div className="ant-upload-text">上传封面</div>
                            </div>
                        }
                        <div style={{paddingLeft: 24}}>
                            <p style={{fontSize: 12}}>
                                请选择或者上传清晰美观的封面 <br/>
                                如不上传封面,则使用默认设置的封面图
                            </p>
                            {/*{body.statusName === "发布" || body.statusName === "已发布" || body.statusName == "正在发布" ? null :*/}
                                <div style={{display: 'flex'}}>
                                    <p style={{width: 74.11, height: 22, color: '#0050B3', cursor: 'pointer'}}
                                       onClick={() => {
                                           window.loading.show()
                                           window.setTimeout(()=>{
                                               this.getVideoBase64(videoUrl).then(res => {
                                                   window.loading.hide();
                                                   this.setState({videoImg: res,editCoverModalVisible: true})
                                               });
                                           }, 50)
                                           this.equalScalingImg(this.state.body)
                                       }}>
                                        视频选封面
                                    </p>
                                    <p style={{
                                        width: 100,
                                        height: 22,
                                        color: '#0050B3',
                                        cursor: 'pointer',
                                        marginLeft: 10
                                    }}
                                       onClick={() => {
                                           this.setState({uploadPictureVisible: true});
                                           this.state.uploadImage = uuid()
                                       }}>
                                        上传图片封面
                                    </p>
                                    <p style={{
                                        width: 100,
                                        height: 22,
                                        color: '#0050B3',
                                        cursor: 'pointer',
                                        marginLeft: 10
                                    }}
                                       onClick={() => {
                                           if(!coverUrl){
                                               rmtMessage.destroy();
                                               rmtMessage.warning("请先选择一张封面图！")
                                           }
                                           this.editCover(coverUrl, "", (path) => {
                                               this.state.body.coverUrl = path;
                                               this.setState({});
                                           })

                                       }}
                                    >
                                        编辑封面
                                    </p>
                                </div>
                            {/*}*/}
                        </div>
                    </div>
                    <Radio.Group value={this.state.coverPicType || 1} onChange={e=>this.setState({coverPicType:e.target.value})}>
                        <Radio value={1}>封面小图</Radio>
                        <Radio value={2}>封面大图</Radio>
                    </Radio.Group>
                </div>
                <div style={{margin:"16px 0"}} id={"video"}>
                    <Publisher label={<span style={{fontSize: '16px', fontWeight: 500, color: 'black'}}><span
                        style={{color: "red"}}>*</span>{" "}发布账号</span>}
                               colon={false}
                               ref={publisherComponent=>this.publisherComponent = publisherComponent}
                               publishId={this.state.body?.variableFields?.publishId || mediaId}
                               publishName={this.state.body?.variableFields?.publishName || mediaName}
                               publishType={(publishType || publishType === 0) ? publishType : rmType}
                               permission={this.state.body?.variableFields?.permission}
                               publishPhoto={this.state.body?.variableFields?.publishPhoto}
                    />
                    <style>
                        {
                            `
                                #video .ant-form-item{
                                    font-size: 16px !important;
                                    font-weight: 500;
                                    color: black;
                                    margin-bottom: 0px !important;
                                }
                                `
                        }
                    </style>
                </div>
            </div>
        )
    }

    hide = (call=()=>{})=>{
        this.setState({
            visible:false,
            releaseVideosVisible:false
        }, ()=>{
            call();
        })
    }

    deliveryNews;
    mainColumn;
    otherAttributesInfo;

    renderPublishDialog = ()=>{
        if(!this.mainColumn){
            this.mainColumn = this.state.videoInitInfo;
            this.state.mediaId = this.mainColumn?.mediaId;
        }
        return <Modal
            title={"发布设置"}
            width={400}
            visible={this.state.publishDialogVisible}
            onOk={()=>{
                let {selectColumnInfo:{mainColumn, deliveryNews}, otherAttributesInfo} = this.getPublish();
                this.mainColumn = mainColumn;
                this.deliveryNews = deliveryNews;
                this.otherAttributesInfo = otherAttributesInfo;
                this.setState({publishDialogVisible:false})
            }}
            onCancel={()=>{
                this.setState({publishDialogVisible:false})
            }}
        >
            <Scrollbars
                autoHeight
                autoHeightMax={600}
            >
                <SelectColumn
                    dynamicParams={{
                        mediaId: this.state.mediaId
                    }}
                    hideMeanwhilePublishSet={true}
                    hideTitle={true}
                    showSelectOperate={false}
                    showCutOperate={this.state.titleModal === "发视频"}
                    selectByLocal={true}
                    selectByLocalFunction={(callBack) => {
                        this.getSelectPic(callBack)
                    }}
                    ref={selectColumn => {
                        this.selectColumn = selectColumn;
                        this.selectColumn && this.selectColumn.setData({mainColumn:this.mainColumn, deliveryNews:this.deliveryNews});
                    }} />
                <OtherAttributes
                    ref={otherAttributes => {
                        this.otherAttributes = otherAttributes;
                        this.otherAttributesInfo && this.otherAttributes && this.otherAttributes.setData(this.otherAttributesInfo);
                    }} />
            </Scrollbars>
        </Modal>
    };

    getSelectPic(callBack) {
        let {videoDuration, videoUrl, videoSrc, editWidth, editHeight} = this.state.body;
        let videoAll = [{
                duration: videoDuration,
                src: videoUrl,
                videoHeight: editHeight,
                videoSrc,
                videoWidth: editWidth,
            }]
        callBack(videoAll);
    }

    checkForm = (body)=>{
        if (!body?.variableFields?.videoUrl) {
            rmtMessage.warning('请上传视频！');
            return false
        }
        if (!body?.title) {
            rmtMessage.warning('请输入视频标题！');
            return false
        }
        if (!body?.content) {
            rmtMessage.warning('请输入视频描述！');
            return false
        }
        if(body.content.length > 100){
            rmtMessage.warning('视频描述字数不能超过100！');
            return false
        }
        if (!body?.titlePic) {
            rmtMessage.warning('请上传视频封面图！');
            return false
        }
        if(!body?.variableFields.publishId){
            rmtMessage.warning('请选择发布账号！');
            return false
        }
        return body
    };

    buildParams(){
        let tempMainColumn = {};
        Object.assign(tempMainColumn, this.mainColumn);
        delete tempMainColumn.id;
        delete tempMainColumn.key;
        if(tempMainColumn.title) {
            delete tempMainColumn.title;
        }
        if(tempMainColumn.treeName && tempMainColumn.treeId) {
            tempMainColumn.columnName = tempMainColumn.treeName;
            tempMainColumn.columnId = tempMainColumn.treeId;
        }
        if(JSON.stringify(tempMainColumn) === "{}"){
            let {mediaId, columnId, columnName} = this.state.videoInitInfo;
            tempMainColumn = {mediaId, columnId, columnName};
        }

        let {body:{id, title, content, coverUrl, videoDuration, videoFileLen, videoName, videoUrl, videoSrc, editWidth, editHeight}, coverPicType} = this.state;
        let {top, recommend, viewNum, initViewNum} = this.otherAttributesInfo;
        let params = {
            id, title, content, titlePic:coverUrl,
            variableFields:{videoDuration, videoFileLen, videoName, videoUrl, videoSrc, initViewNum, editWidth, editHeight, coverPicType, ...this.publisherComponent.getData()},
            ...tempMainColumn,
            top,
            recommend,
            viewNum,
            deliveryMediaFusionList:this.deliveryNews,
            // submitter: window.currentUser.account,
            type : 2
        };
        return params;
    }

    save = (status = "草稿", op = "暂存")=>{
        let params = this.buildParams();
        if(!this.checkForm(params)){
            return;
        }
        params.content = base64Encode(params.content);
        params.statusName = status;
        let url = '/cm-sites-mmp/mf/save';
        this.request({
            url,
            method: 'POST',
            body: params,
            contentType: 'json',
            callBack: (res)=>{
                if(res?.id){
                    rmtMessage.success(op+ '成功！');
                }
                this.hide(()=>this.props.onOkCall());
            }
        });
    };

    getPublish(){
        let selectColumnInfo = this.selectColumn?.getData() || {};
        if(JSON.stringify(selectColumnInfo) === "{}"){
            let {columnId, columnName,mediaId} = this.state.videoInitInfo;
            selectColumnInfo.mainColumn = {id:columnId, columnName,mediaId};
        }
        let otherAttributesInfo = this.otherAttributes?.getData() || {};
        return {selectColumnInfo, otherAttributesInfo}
    }
}

export default Video;
